import {API_TASKS} from 'consts/api'
import {Cancelled, TaskError} from './errors.js'
import Rest from './rest.js'
import {nextTick} from 'vue'


import * as $utils from 'utils';
export const TASK_STATUS = {
  COMPLETED: 'completed',
  FAILED: 'failed',
  RUNNING: 'running',
  CANCELED: 'cancelled'
}

export default class Tasks {
  constructor() {
    this._rest = new Rest()
    this._tasks = []
  }

  async start(apiUrl, args = {}, config = {}) {
    try {
      const res = await this._rest.post(apiUrl, args, config)
      return res.id
    } catch (err) {
      if (err.http_code === 400) {
        $utils.toasts.error(err.message)
      }
    }
  }

  async get(task_id, options) {
    return await this._rest.get(`${API_TASKS}/${task_id}`, undefined, options)
  }

  async get_since(task_id, since) {
    return await this._rest.get(`${API_TASKS}/${task_id}`, {since: since})
  }

  async exists(task_id) {
    const task = await this.get(task_id, {throw_404: false})
    return task !== undefined
  }

  async getArg(task_id) {
    const {task_arg} = await this.get(task_id)
    return JSON.parse(task_arg)
  }

  cancelOne(task_id) {
    //TODO: For one task rests are not abortable
    // do we need to abort all rests?
    const task = this._tasks.find(x => x.task_id === task_id)
    if (task) {
      this._killTask(task)
    }
  }

  cancelAll(cancel_on_server = true) {
    this._rest.abortAll()
    for (const task of this._tasks) {
      this._killTask(task, cancel_on_server)
    }
    this._tasks = []
  }

  _killTask(task, cancel_on_server) {
    clearTimeout(task.timeout_id)
    task.reject(new Cancelled())
    if (cancel_on_server) {
      nextTick(async () => this._rest.post(`${API_TASKS}/${task.task_id}/cancel`, {}))
    }
  }

  //
  //
  // N.B. waitResult - throws on task errors (failed task itself) & cancellation
  //      waitTasks  - never throws on task errors & cancellation, just returns the whole tasks
  //                   handling task errors is responsibility of the caller
  //
  //
  async waitResult(task_id, timeout = 1000, intermediate_cback = undefined, since = undefined) {
    const data = since ? await this.get_since(task_id, since) : await this.get(task_id)
    this._tasks = this._tasks.filter(task => task.task_id !== task_id)

    if (data) {
      since = data.updated_at
      switch (data.status) {
        case TASK_STATUS.COMPLETED: return data.result
        case TASK_STATUS.FAILED: throw new TaskError(task_id, data.error)
        case TASK_STATUS.CANCELED: throw new Cancelled()
      }

      if (intermediate_cback && data.result) {
        intermediate_cback(data.result)
      }
    }

    return new Promise((resolve, reject) => {
      const timeout_id = setTimeout(
        () => resolve(this.waitResult(task_id, timeout, intermediate_cback, since)
        ), timeout)
      this._tasks.push({reject, timeout_id, task_id})
    })
  }

  async waitTask(task_id, timeout = 1000, intermediate_cback = undefined, since = undefined) {
    const data = since ? await this.get_since(task_id, since) : await this.get(task_id)
    this._tasks = this._tasks.filter(task => task.task_id !== task_id)

    if (data) {
      since = data.updated_at
      switch (data.status) {
        case TASK_STATUS.COMPLETED: return data
        case TASK_STATUS.FAILED: return data
        case TASK_STATUS.CANCELED: return data
      }

      if (intermediate_cback && data) {
        intermediate_cback(data)
      }
    }

    return new Promise((resolve, reject) => {
      const timeout_id = setTimeout(
        () => resolve(this.waitTask(task_id, timeout, intermediate_cback, since)
        ), timeout)
      this._tasks.push({reject, timeout_id, task_id})
    })
  }
}
